import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  salaryData: boolean;
}

const initialState: AuthState = {
  salaryData: false,
};

const salaryDataSlice = createSlice({
  name: 'salaryData',
  initialState,
  reducers: {
    setSalaryData: (state, action: PayloadAction<boolean>) => {
      state.salaryData = action.payload;
    },
    clearSalaryData: state => {
      state.salaryData = false;
    },
  },
});

export const { setSalaryData, clearSalaryData } = salaryDataSlice.actions;
export default salaryDataSlice.reducer;
